import React from "react";
import { Typography as MatTypography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Ride",
    textTransform: "none",
    // to be used for text on white background
    color: theme.hertzColors.eightyBlack,
  },
  // to be used for text on yellow background
  ninetyBlack: {
    color: theme.hertzColors.ninetyBlack,
  },
}));

const Typography = (props) => {
  const classes = useStyles();
  let style = `${classes.root}`;
  style = `${style} ${classes[props.color]} ${props.className}`;
  style = `${style} ${classes[props.variant]}`;

  return (
    <MatTypography className={style} {...props}>
      {props.children}
    </MatTypography>
  );
};

export default Typography;
